import { ServiceWorkerService } from "../shared/services/service-worker.service";
import {
  AUTH_ERROR,
  DOWNLOAD_COMPLETED,
  DOWNLOAD_STATUS,
  REQUEST_CACHE_EXPORT,
  REQUEST_SITE_DOWNLOAD,
  REQUEST_SITE_SYNC,
  SYNC_COMPLETED,
  SYNC_STATUS,
} from "./event.const";
import { OfflineCacheExportPayload } from "./cache-export";
import { authRedirect } from "../../http-client/utils/redirect.utils";
import { getCsrfTokenFromCookie } from '../../http-client/utils/csrf.utils';

export const downloadSite = (organizationCode: string, siteId: string, selectedBuildingIds: string[], downloadOutdoorAreas: boolean) => {
  if (ServiceWorkerService.isServiceWorkerEnabled()) {

    return ServiceWorkerService.sendMessage(REQUEST_SITE_DOWNLOAD, {
      orga: organizationCode,
      siteId,
      xsrfToken,
      selectedBuildingIds,
      downloadOutdoorAreas,
    }).then((status: DOWNLOAD_STATUS) => {
      if (status === DOWNLOAD_COMPLETED) {
        return status;
      }
      if (status === AUTH_ERROR) {
        return authRedirect();
      }
      throw status;
    });
  } else {
    throw new Error("Service Worker not supported");
  }
};

export const synchronizeSite = (organizationCode: string, siteId: string, selectedBuildingIds?: string[], syncOutdoorAreas?: boolean) => {
  if (ServiceWorkerService.isServiceWorkerEnabled()) {
    // Si undefined, on synchronise tout le site (comme l'ancien bouton) -> passer un tableau vide
    // Si un tableau avec des IDs, on synchronise uniquement ces bâtiments
    return ServiceWorkerService.sendMessage(REQUEST_SITE_SYNC, {
      orga: organizationCode,
      siteId,
      xsrfToken,
      selectedBuildingIds: selectedBuildingIds || [],
      syncOutdoorAreas: syncOutdoorAreas !== undefined ? syncOutdoorAreas : true,
    }).then((status: SYNC_STATUS) => {
      if (status === SYNC_COMPLETED) {
        return status;
      }
      if (status === AUTH_ERROR) {
        return authRedirect();
      }
      throw status;
    });
  } else {
    throw new Error("Service Worker not supported");
  }
};

export const exportOfflineCache = (
  organizationCode: string | null,
  appVersion: string
): Promise<OfflineCacheExportPayload> => {
  if (!ServiceWorkerService.isServiceWorkerEnabled()) {
    throw new Error("Service Worker not supported");
  }

  return ServiceWorkerService.sendMessage(REQUEST_CACHE_EXPORT, {
    orga: organizationCode,
    appVersion,
  }).then((response: { ok: boolean; payload?: OfflineCacheExportPayload; error?: string }) => {
    if (response?.ok && response.payload) {
      return response.payload;
    }
    throw new Error(response?.error ?? "Cache export failed");
  });
};

const xsrfToken = getCsrfTokenFromCookie();
